import { atom } from "jotai"
import { atomWithStorage } from "jotai/utils"
import { StyleTab } from "@/store/style/style-types"
import { safeJSONSessionStorage } from "@/utils/safe-jotai-storage"

const DEFAULT_TAB: StyleTab = "user"
const VALID_TABS: StyleTab[] = ["user", "polarr", "internal"]

const rawAiStylesTabAtom = atomWithStorage<StyleTab>(
	"ai_styles_tab",
	DEFAULT_TAB,
	safeJSONSessionStorage<StyleTab>(),
)

export const aiStylesTabAtom = atom(
	(get) => {
		const value = get(rawAiStylesTabAtom)
		return VALID_TABS.includes(value) ? value : DEFAULT_TAB
	},
	(_get, set, next: StyleTab) => {
		void set(rawAiStylesTabAtom, VALID_TABS.includes(next) ? next : DEFAULT_TAB)
	},
)
